export const HISTORY_ACTIONS_KEYS = {
  addQueryHistory: 'addQueryHistory',
  addQueryToSessionQueryHistory: 'addQueryToSessionQueryHistory',
  addResultIdToClicksHistory: 'addResultIdToClicksHistory',
  clearQueryHistory: 'clearQueryHistory',
  loadClickedResultHistory: 'loadClickedResultHistory',
  loadQueryHistory: 'loadQueryHistory',
  loadSessionQueryHistory: 'loadSessionQueryHistory',
  removeQueryHistory: 'removeQueryHistory',
  setEnabledQueryHistory: 'setEnabledQueryHistory'
} as const;

export const HISTORY_GETTERS_KEYS = {
  queryHistory: 'queryHistory',
  version: 'version',
  storageKey: 'storageKey'
} as const;

export const HISTORY_MUTATIONS_KEYS = {
  removeQueryHistory: 'removeQueryHistory',
  setEnabledQueryHistory: 'setEnabledQueryHistory',
  setQueryHistory: 'setQueryHistory',
  setClickedResultHistory: 'setClickedResultHistory',
  setSessionQueryHistory: 'setSessionQueryHistory'
} as const;

export const CLICKED_RESULT_HISTORY_KEY = 'clicked-result-history';
export const SESSION_QUERY_HISTORY_KEY = 'session-query-history';
export const MAX_QUERY_HISTORY_SIZE = 50;

export enum historyItemStrategy { none, replace, add}
